import { render } from "../views/info_panel.html?vue&type=template&id=72894a15&ts=true&external"
import script from "../scripts/info_panel.ts?vue&type=script&lang=ts&external"
export * from "../scripts/info_panel.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/info_panel.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/info_panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72894a15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72894a15', __exports__)) {
    api.reload('72894a15', __exports__)
  }
  
  module.hot.accept("../views/info_panel.html?vue&type=template&id=72894a15&ts=true&external", () => {
    api.rerender('72894a15', render)
  })

}


export default __exports__